import { ChevronRight, Phone, AlertTriangle, Info, ChevronLeft } from "react-feather";
import { Button } from "reactstrap";
import NavbarSms from "../../../../../@core/layouts/components/navbar/NavbarSms";
import { padding } from "polished";

const KeywordAction = (props) => {
  const {
    keywordAction,
    onContinue,
    onCancel,
    shop,
  } = props;

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    return [
      phoneNumber.slice(0, 3),
      phoneNumber.slice(3, 6),
      phoneNumber.slice(6)
    ].join('-');
  };

  return (
    <div className="keyword-action-wrapper">
      {/* Modern Alert Header */}
      <div className="keyword-action-header mb-2">
        <div className="d-flex align-items-center justify-content-center">
          <div className="keyword-action-icon-wrapper mr-1 vertical-align-top">
            <AlertTriangle size={24} color="#f59e0b" />
          </div>
          <div>
            <h4 style={{
              color: '#1f2937',
              fontWeight: '600',
              fontSize: '1.25rem',
              marginBottom: '8px'
            }}>
              Important Notice
            </h4>
            <p className="mb-0" style={{
              color: '#6b7280',
              fontSize: '0.875rem'
            }}>
              Please review this information before continuing to {shop?.metadata?.isAutoAccept ? 'complete booking' : 'complete request'}
            </p>
          </div>
        </div>
      </div>

      {/* Alert Content */}
      <div className="keyword-action-body mb-2">
        <div className="alert-content-wrapper" style={{
          backgroundColor: '#fef3c7',
          border: '1px solid #f59e0b',
          borderRadius: '12px',
          padding: '16px',
          position: 'relative'
        }}>
          <div className="d-flex align-items-start">
            <Info size={20} color="#d97706" className="mr-1" style={{ flexShrink: 0, marginTop: '10px' }} />
            <div>
              <p className="mb-0" style={{
                color: '#92400e',
                fontSize: '1rem',
                lineHeight: '1.5',
                fontWeight: '500'
              }}>
                {keywordAction?.info_message}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="keyword-action-footer">
        {!keywordAction?.allow_bypass && (
          <div className="contact-section mb-2">
            <div className="contact-wrapper" style={{
              backgroundColor: '#F8F9FA',
              border: '1px solid #E2E8F0',
              borderRadius: '16px',
              padding: '24px',
              textAlign: 'center'
            }}>
              <h5 className="mb-1" style={{
                color: '#1F2937',
                fontWeight: '600',
                fontSize: '1.125rem'
              }}>
                Contact Us
              </h5>
              <p className="mb-1" style={{
                color: '#6b7280',
                fontSize: '0.875rem'
              }}>
                For assistance with this request, please call or text us:
              </p>

              <Button
                style={{
                  padding: '12px 24px',
                  borderRadius: '25px',
                  border: '2px solid #03464C',
                  backgroundColor: 'transparent',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#03464C',
                  marginBottom: '16px',
                  transition: 'all 0.2s ease',
                  minWidth: '160px'
                }}
                href={`tel:${shop?.phone}`}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#03464C';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#03464C';
                }}
              >
                <Phone className='mr-1' style={{ marginBottom: '2px' }} size={16} />
                {formatPhoneNumber(shop?.phoneNumber)}
              </Button>

              <div className="text-divider mb-1" style={{
                display: 'flex',
                alignItems: 'center',
                color: '#9CA3AF',
                fontSize: '0.875rem'
              }}>
                <div style={{ flex: 1, height: '1px', backgroundColor: '#E5E7EB' }}></div>
                <span className="mx-3">or</span>
                <div style={{ flex: 1, height: '1px', backgroundColor: '#E5E7EB' }}></div>
              </div>

              <NavbarSms buttonText="Text us instead" />
            </div>
          </div>
        )}

        <div className="keyword-action-footer">
          {keywordAction?.allow_bypass && (
            <div className="d-flex flex-column align-items-center w-100">
              <Button
                type="button"
                color="primary"
                className="custom-client-type-picker-button mb-2"
                style={{
                  fontWeight: '600',
                  marginBottom: '6px'
                }}
                onClick={onContinue}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <span>
                    {keywordAction?.action_type === 'prompt' ? (
                      keywordAction?.prompt_message
                    ) : (
                      'Continue'
                    )}
                  </span>
                  <ChevronRight style={{ marginLeft: '5px' }} size={20} />
                </div>
              </Button>
            </div>
          )}

          {keywordAction?.action_type === 'prompt' && (
            <Button
              type="button"
              color="text-primary"
              className="custom-client-type-picker-button mb-1"
              style={{
                fontWeight: '600',
                fontSize: '14px',
                marginRight: '10px'
              }}
              onClick={onCancel}
            >
              <ChevronLeft style={{ marginRight: '3px' }} size={20} />
              Go back
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default KeywordAction;
